<template>
	<div>
		<!-- 查询表单 -->
		<div class="filters">
			<el-form :inline="true">
				<el-form-item>
					<el-input class="searchInput" v-model="content" :placeholder="$t('lang.lab_voteContent')" clearable></el-input>
				</el-form-item>
				<el-button type="primary" @click="selectList()">{{$t('lang.btn_selVote')}}</el-button>
			</el-form>
		</div>
		<!-- 投票表格 -->
		<el-card>
			<el-button slot="header" size="medium" type="primary" @click="add()">{{$t('lang.btn_addVote')}}</el-button>
			<el-table :data="voteList" class="wid100" :height="voteList.length > 0 ? 529 : 109">
				<el-table-column type="index" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
				<el-table-column prop="content" :label="$t('lang.lab_voteContent')"></el-table-column>
				<el-table-column prop="type" :label="$t('lang.lab_voteType')">
					<template slot-scope="scope">
						<span v-if="scope.row.type == 1">{{$t('lang.radio_voteOne')}}</span>
						<span v-if="scope.row.type == 2">{{$t('lang.radio_voteMore')}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="operation" :label="$t('lang.lab_operation')" width="150px">
					<template slot-scope="scope">
						<el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
						&nbsp;
						<el-popconfirm :confirmButtonText="$t('lang.btn_confirm')" :cancelButtonText="$t('lang.btn_cancel')" icon="el-icon-info" iconColor="red" :title="$t('lang.lab_voteIsDelete')"
							@onConfirm="del(scope.row.id)">
							<el-button class="orange" slot="reference">{{$t('lang.btn_delete')}}</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
				:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper" :page-count="pageCount" />
		</el-card>
		<!-- 添加投票 -->
		<el-dialog :title="$t('lang.btn_addVote')" :visible.sync="addVoteFormVisible" :close-on-click-modal="false" center
			top="130px" width="600px">
			<el-form :model="voteForm" :rules="rules" ref="voteForm">
				<el-form-item :label="$t('lang.lab_voteContent')" label-width="120px" prop="content">
					<el-input v-model="voteForm.content" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_voteType')" label-width="120px" prop="type">
					<el-radio-group v-model="voteForm.type">
						<el-radio label=1>{{$t('lang.radio_voteOne')}}</el-radio>
						<el-radio label=2>{{$t('lang.radio_voteMore')}}</el-radio>
					</el-radio-group>
				</el-form-item>

				<!-- 循坏选项组成数组 传content -->
				<el-form-item v-for="(item,index) in voteForm.optionLabel" :key="index" label-width="120px" style="display: inline-block;"
					:label="$t('lang.lab_option') + (index+1)" :model="item" :prop="`optionLabel[${index}]`" :rules="rulesOptions">
					<el-input :placeholder="$t('lang.lab_inputOptionContent')" v-model="voteForm.optionLabel[index]" style="width: 180px;"></el-input>
					&nbsp;
					<el-link type="info" :underline="false" @click="delOption(index)" v-if="index>voteForm.optionLabel.length-2&&index>1">
						<i class="el-icon-minus" />
					</el-link>
					&nbsp;
					<el-link type="info" :underline="false" @click="addOption" size="mini" v-if="index>voteForm.optionLabel.length-2">
						<i class="el-icon-plus" />
					</el-link>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addVoteFormVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="addVote(voteForm)">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>
		<!-- 修改投票 -->
		<el-dialog :title="$t('lang.btn_addVote')" :visible.sync="editVoteFormVisible" :close-on-click-modal="false" center
			top="130px" width="600px">
			<el-form :model="voteForm" :rules="rules" ref="voteForm">
				<el-form-item :label="$t('lang.lab_voteContent')" label-width="120px" prop="content">
					<el-input v-model="voteForm.content" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_voteType')" label-width="120px" prop="type">
					<el-radio-group v-model="voteForm.type">
						<el-radio :label=1>{{$t('lang.radio_voteOne')}}</el-radio>
						<el-radio :label=2>{{$t('lang.radio_voteMore')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-for="(item,index) in voteForm.optionLabel" :key="index" label-width="120px" style="display: inline-block;"
					:label="$t('lang.lab_option') + (index+1)" :model="item.label" :prop="`optionLabel[${index}]`" :rules="rulesOptions">
					<el-input :placeholder="$t('lab_inputOptionContent')" v-model="item.label" style="width: 180px;"></el-input>
					&nbsp;
					<el-link type="info" :underline="false" @click="delOption(index)" v-if="index>voteForm.optionLabel.length-2&&index>1">
						<i class="el-icon-minus" />
					</el-link>
					&nbsp;
					<el-link type="info" :underline="false" @click="addOption" size="mini" v-if="index>voteForm.optionLabel.length-2">
						<i class="el-icon-plus" />
					</el-link>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editVoteFormVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="editVote(voteForm)">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'

	export default {
		name:'/manage/main.voteList',
		data() {
			return {
				pageCount: 0,
				pageNo: 1,
				pageSize: 10,
				content: '',
				voteList: [],

				addVoteFormVisible: false,
				voteForm: {
					id: '',
					content: '',
					type: '',
					optionLabel: []
				},
				editVoteFormVisible: false,

				rules: {
					content: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_voteContent'),
						trigger: 'blur'
					}],
					type: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_Type'),
						trigger: 'change'
					}],
				},
				rulesOptions: [{
					required: true,
					message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_optionContent'),
					trigger: 'blur'
				}]
			}
		},
		created() {
			this.selectList()
		},
		computed: {
      ...mapGetters(['gardenId'])
    },
		methods: {
			selectList() {
				let loading = this.$loading()
				let param = {
					gardenId: this.gardenId,
					content: this.content,
					pageNo: this.pageNo,
					pageSize: this.pageSize
				}
				this.$post(`/vote/voteList`, param)
					.then(res => {
						this.voteList = res.list
						this.pageCount = res.pageCount
						loading.close()
						// console.log(this.voteList)
					})
					.catch(err => {
						console.log(err)
					})
			},
			add() {
				this.addVoteFormVisible = true
				this.voteForm.content = ''
				this.voteForm.type = ''
				this.voteForm.optionLabel = ['', '']
				/* 弹出窗不加这个 验证会监听变化 刚打开dialog就会校验 */
				this.$nextTick(() => {
					this.$refs.voteForm.clearValidate()
				})
			},
			addOption() {
				this.voteForm.optionLabel.push('')
			},
			delOption(index) {
				// var index = this.voteForm.optionLabel.indexOf(item)
				if (index > 1) {
					this.voteForm.optionLabel.splice(index, 1)
				}
			},
			addVote(voteForm) {
				this.$refs.voteForm.validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						let param = {
							'content': voteForm.content,
							'type': voteForm.type,
							'gardenId': this.gardenId,
							'optionLabel[]': voteForm.optionLabel.toString()
						}
						this.$post(`/vote/add`, param)
							.then(res => {
								this.$message.success(this.$i18n.t('lang.lab_save_success'))
								this.selectList()
								this.addVoteFormVisible = false
								loading.close()
							})
							.catch(err => {
								console.log(err)
								this.$message.error(this.$i18n.t('lang.resourAddLose'))
								loading.close()
							})
					} else {
						// console.log('error submit!!')
						return false
					}
				})
			},
			edit(row) {
				this.editVoteFormVisible = true
				this.voteForm.id = row.id
				this.voteForm.content = row.content
				this.voteForm.type = row.type
				this.voteForm.optionLabel = row.option
				// console.log(row.option) 
			},
			editVote(voteForm) {
				var option = []
				for (let i in voteForm.optionLabel) {
					option.push(voteForm.optionLabel[i].label)
				}
				// console.log(option)
				this.$refs.voteForm.validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						let param = {
							'id': this.voteForm.id,
							'content': voteForm.content,
							'type': voteForm.type,
							'gardenId': this.gardenId,
							'optionLabel[]': option.toString()
						}
						this.$post(`/vote/update`, param)
							.then(res => {
								this.$message.success(this.$i18n.t('lang.lab_save_success'))
								this.selectList()
								this.editVoteFormVisible = false
								loading.close()
							})
							.catch(err => {
								console.log(err)
								this.$message.error(this.$i18n.t('lang.resourAddLose'))
								loading.close()
							})
					} else {
						// console.log('error submit!!')
						return false
					}
				})
			},
			del(id) {
				let loading = this.$loading()
				let param = {
					id: id
				}
				this.$post(`/vote/del`, param)
					.then(response => {
						if (response && response.errCode === 0) {
							this.$message({
								type: 'success',
								message: this.$i18n.t('lang.lab_del_success')
							})
							this.selectList()
							loading.close()
						}
					})
					.catch(error => {
						this.$message({
							type: 'error',
							message: this.$i18n.t('lang.lab_del_fail')
						})
						loading.close()
						console.log(error)
					})
			},
			// 点击换页
			handleCurrentChange(val) {
				this.pageNo = val
				this.selectList()
			},
			// 点击更改每页容量
			handleSizeChange(val) {
				this.pageNo = 1
				this.pageSize = val
				this.selectList()
			},
		}
	}
</script>

<style>
</style>
